"use client"

import * as PopoverPrimitive from "@radix-ui/react-popover"
import * as React from "react"

import { cn } from "@/lib/tailwind"
import { CloseButton } from "./CloseButton"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-48 rounded-md border bg-popover text-popover-foreground shadow-md outline-none data-[state=closed]:animate-out data-[state=open]:animate-in",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export const PopoverArrow = PopoverPrimitive.Arrow

export const PopoverPortal = PopoverPrimitive.Portal

export const PopoverHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex w-full items-start justify-between border-b py-1 pr-1 pl-3">
      <p className="pt-1 font-bold">{children}</p>
      <div>
        <PopoverPrimitive.Close asChild>
          <CloseButton size="xs" />
        </PopoverPrimitive.Close>
      </div>
    </div>
  )
}

export { Popover, PopoverTrigger, PopoverContent }
